import { render } from "./ParametersCards.vue?vue&type=template&id=f7446f28&scoped=true"
import script from "./ParametersCards.vue?vue&type=script&lang=js"
export * from "./ParametersCards.vue?vue&type=script&lang=js"

import "./ParametersCards.vue?vue&type=style&index=0&id=f7446f28&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7446f28"]])

export default __exports__